export default function Field({
  label,
  name,
  type = "text",
  value,
  onChange,
  onBlur,
  error,
  optional = false,
  placeholder = "",
  inputMode,
  autoComplete,
  list,
  testid,
}) {
  const id = `alta-field-${name}`;
  return (
    <div className="group">
      <label
        htmlFor={id}
        className="flex items-baseline justify-between font-mono text-[10px] tracking-[0.3em] text-steel mb-3"
      >
        <span>{label}</span>
        {optional && <span className="text-steel/60 tracking-[0.2em]">OPCIONAL</span>}
      </label>
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        inputMode={inputMode}
        autoComplete={autoComplete}
        list={list}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        data-testid={testid || id}
        className={`w-full bg-panel/40 border px-5 py-4 text-offwhite text-base placeholder:text-steel/50 outline-none transition-[border-color,background-color] duration-300 hover:border-silver/25 focus:border-glow/70 focus:bg-panel/70 ${
          error ? "border-red-400/70" : value ? "border-silver/35" : "border-silver/10"
        }`}
      />
      {error && (
        <p id={`${id}-error`} role="alert" data-testid={`${id}-error`} className="mt-2 text-xs text-red-300/90">
          {error}
        </p>
      )}
    </div>
  );
}
